// extracted by mini-css-extract-plugin
module.exports = {"filterTitle":"MobileHead_filterTitle__8Nqo_"};